import React from "react";
import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { currencyFormatter } from "@common/helpers/currency";
import { isNumber } from "@common/helpers/typeGuards";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CounterpartyDirectoryViewRow } from "../counterpartyDirectoryViewTypes";
import styles from "../DirectoryTable.module.scss";

export const CounterpartyAmountCell: React.FC<
    CellContext<ViewTableFeatures, CounterpartyDirectoryViewRow, number>
> = React.memo(({ getValue }) => {
    const value = getValue();
    if (!isNumber(value)) {
        return <ViewTableCell />;
    }
    return (
        <ViewTableCell className={styles.amount}>
            {currencyFormatter.format(value)}
        </ViewTableCell>
    );
});

CounterpartyAmountCell.displayName = "CounterpartyAmountCell";
